import type { SchedulingPresentationPolicy } from "@/customer-interface/scheduling";
import { AppointmentType } from "@/shared/models/appointment";
import { SchedulingPresentation, SchedulingSlotKind } from "@/shared/scheduling/contract";

/** Service classification and unit membership come from the existing schedule.yaml action policy. */
export const nimbusSchedulingPresentation: SchedulingPresentationPolicy = {
  describeService({ appointmentType, appointmentPolicyTags }) {
    if (appointmentPolicyTags.includes("pft")) {
      return { serviceLabel: "Pulmonary function test", targetKind: SchedulingSlotKind.Resource };
    }

    switch (appointmentType) {
      case AppointmentType.INITIAL_CONSULTATION:
        return { serviceLabel: "Initial consultation", targetKind: SchedulingSlotKind.Provider };
      case AppointmentType.FOLLOW_UP:
        return { serviceLabel: "Follow-up consultation", targetKind: SchedulingSlotKind.Provider };
      default:
        return undefined;
    }
  },
  describeRescheduleUnit(policyId) {
    return policyId === "pft_follow_up_pair" ? SchedulingPresentation.SingleVisit : undefined;
  },
};
